export { default as DialogActions } from '@material-ui/core/DialogActions'
export { default as DialogContent } from '@material-ui/core/DialogContent'
export { default as DialogContentText } from '@material-ui/core/DialogContentText'
export { default as DialogTitle } from '@material-ui/core/DialogTitle'

export default from '@material-ui/core/Dialog'
